import { Flex, List, Tag, Typography } from 'antd';
import { FC, memo } from 'react';
import { ArrowRight } from 'react-bootstrap-icons';

import { PageNode } from '@/modules/Pages';

interface Props {
  items: Pick<PageNode, 'id' | 'path'>[];
  targetLabel: string;
}

export const RedirectsBulkTargetPreviewList: FC<Props> = memo(({ items, targetLabel }) => {
  if (!items.length) return null;

  return (
    <List
      size="small"
      bordered
      dataSource={ items }
      rowKey="id"
      pagination={ { pageSize: 50, size: 'small', showSizeChanger: true, pageSizeOptions: [50, 100, 200] } }
      renderItem={ ({ id, path }) => (
        <List.Item key={ id }>
          <Flex gap={ 6 } align="center" wrap="wrap">
            <Typography.Text>{ path }</Typography.Text>
            <ArrowRight size={ 14 }/>
            <Tag color="green">{ targetLabel }</Tag>
          </Flex>
        </List.Item>
      ) }
    />
  );
});
